import { GRAND_PRIZE_URL, EVENT_WINNER_URL, SHOP_MORE_URL } from '../Constants';

interface RedirectPage {
  type: string;
  data: any;
}
function setupTopShopperNavigator(platform: string, eventName: string, grandEventName: string) {
  return function redirectPage(props: RedirectPage): void {
    const { type = '', data = '' } = props;
    let url = '';
    switch (type) {
      case 'GRAND_PRIZE':
        if (eventName && grandEventName) {
          url = `${GRAND_PRIZE_URL}?event=${eventName}&grandEvent=${grandEventName}`;
        }
        break;
      case 'EVENT_WINNER':
        if (eventName && grandEventName) {
          url = `${EVENT_WINNER_URL}?event=${eventName}&grandEvent=${grandEventName}`;
        }
        break;
      case 'UPCOMING_EVENTS':
        if (eventName && grandEventName) {
          url = `${EVENT_WINNER_URL}?event=${eventName}&grandEvent=${grandEventName}#upcoming-event`;
        }
        break;
      case 'PLP':
        url = data || SHOP_MORE_URL;
        break;
      case 'HOME_PAGE':
        url = `/`;
        break;
      default: // do nothing
    }
    if (url) {
      //   redirect(url);
      window.location.href = url;
    }
  };
}

export default setupTopShopperNavigator;
